import TemplateFaq from './TemplateFaq'

export default TemplateFaq
